import Vue from 'vue'

import ElementUI from 'element-ui'; // 2.1引入结构
import 'element-ui/lib/theme-chalk/index.css'; // 2.2引入样式
import App from './App.vue'


Vue.use(ElementUI); // 3.安装
/* eslint-disable no-new */
new Vue({
  // router,
  el: '#app',
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/module/productSpring/productSpring.js